<template>
  <v-snackbar
    :model-value="authzSnackbarVisible"
    :timeout="3000"
    color="red"
    top
    @update:model-value="hideAuthzError"
  >
    {{ authzSnackbarMessage }}
  </v-snackbar>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const authzSnackbarVisible = computed(() => store.getters.authzSnackbarVisible);
const authzSnackbarMessage = computed(() => store.getters.authzSnackbarMessage);

function hideAuthzError() {
  store.dispatch("hideAuthzError");
}
</script>
